import { Link } from "react-router-dom";
import { Tool } from "@/data/tools";

interface ToolCardProps {
  tool: Tool;
}

export default function ToolCard({ tool }: ToolCardProps) {
  return (
    <Link 
      to={`/tool/${tool.id}`}
      className="card hover:-translate-y-1"
    >
      <div className="p-5">
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-lg font-semibold text-gray-800">{tool.name}</h3>
          <span className={`text-xs px-2 py-1 rounded-full ${
            tool.price === 'Free' ? 'bg-green-100 text-green-800' : 
            tool.price === 'Freemium' ? 'bg-blue-100 text-blue-800' :
            'bg-purple-100 text-purple-800'
          }`}>
            {tool.price}
          </span>
        </div>
        <p className="text-gray-600 mb-4 text-sm line-clamp-2">{tool.description}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="flex text-yellow-400 mr-2">
              {[...Array(5)].map((_, i) => (
                <i 
                  key={i} 
                  className={`fa-solid fa-star text-sm ${
                    i < Math.floor(tool.rating) ? 'text-yellow-400' : 'text-gray-300'
                  }`}
                ></i>
              ))}
            </div>
            <span className="text-gray-500 text-sm">{tool.rating.toFixed(1)}</span>
          </div>
          <div className="text-xs text-gray-500">
            {tool.popularity}% popular
          </div>
        </div>
      </div>
    </Link>
  );
}